import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_1.webp';
import projectImage2 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_2.webp';
import projectImage3 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_3.webp';
import projectImage4 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_4.webp';
import projectImage5 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_5.webp';
import projectImage6 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_6.webp';

import Data_IndustrialHazardRecognitionProgram from './Data_IndustrialHazardRecognitionProgram';

function Work_IndustrialHazardRecognitionProgram() {
    const canonical = 'https://studio.norcat.org/OurWork/industrial-hazard-recognition-program';
    const title = 'Hazard Recognition Program | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, the Hazard Recognition Program uses scenario-based VR training to help learners identify workplace hazards, strengthen situational awareness, and build safer on-the-job decision-making.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the Hazard Recognition Program VR training project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the Hazard Recognition Program VR training project"
            />
            <DetailedHeader
                heading="Building Real-World Readiness in Hazardous Environments"
                client="NORCAT (Internal)"
                service="Virtual Reality"
                date="2026"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=ClBHO6a_ROc"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Hazard Recognition Program project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'Hazard Recognition Program project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'Hazard Recognition Program project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'Hazard Recognition Program project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'Hazard Recognition Program project screenshot 5',
                    },
                    {
                        image: projectImage6,
                        alt: 'Hazard Recognition Program project screenshot 6',
                    },
                ]}
            />

            {Data_IndustrialHazardRecognitionProgram.content}
        </>
    );
}

export default Work_IndustrialHazardRecognitionProgram;
